"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Backbone_Icon_List = void 0;
var noun_modal = void 0;
var noun_user = void 0;
var url_to_array = void 0;

Backbone_Icon_List = require("./backbone_iconlist").default;

noun_modal = require("./noun_modal").default;

noun_user = require("../helpers/noun_user").default;

url_to_array = require("../helpers/url_to_array").default;

var Accounts = function Accounts(props) {
  _classCallCheck(this, Accounts);

  $(document).ready(function () {
    var $iconsDownloaded = void 0;
    var $iconsFlagged = void 0;
    var $iconsPending = void 0;
    var $iconsPurchased = void 0;
    var $iconsUploaded = void 0;
    var authentication = void 0;
    var closeInformationModal = void 0;
    var domain = void 0;
    var downloads_url = void 0;
    var flagged_url = void 0;
    var list = void 0;
    var on_finish = void 0;
    var on_load = void 0;
    var page = void 0;
    var pending_url = void 0;
    var purchased_url = void 0;
    var share = void 0;
    var share_modal = void 0;
    var uploads_url = void 0;
    var user_uploads_template = void 0;
    var username = void 0;
    domain = url_to_array;
    page = domain[3];
    if (page === "dashboard") {
      username = noun_user.username;
    } else {
      username = url_to_array[3];
    }
    share_modal = {
      type: "share",
      style: "full-blur",
      authenticate: false
    };
    on_finish = function on_finish() {
      return $(".close-button").on("click", function (e) {
        e.preventDefault();
        return noun_modal.dismiss();
      });
    };
    share = noun_modal.init(share_modal, $("body"), "click", on_load = on_finish, authentication = false, "a.share");
    if ($(".infinite-page").length > 0) {
      $iconsUploaded = $("#icons-uploaded");
      if ($iconsUploaded.length > 0) {
        uploads_url = "//" + url_to_array[2] + "/" + username + "/uploads/json/";
        if ($("#handlebar-template-uploads").length > 0) {
          user_uploads_template = $("#handlebar-template-uploads");
          uploads_url = "//" + url_to_array[2] + "/dashboard/uploads/json/";
        }
        list = new Backbone_Icon_List("#icons-uploaded", uploads_url, 2, user_uploads_template, 72);
      }
      $iconsDownloaded = $("#icons-downloaded");
      if ($iconsDownloaded.length > 0) {
        downloads_url = "//" + url_to_array[2] + "/" + username + "/downloads/json/";
        list = new Backbone_Icon_List("#icons-downloaded", downloads_url, 2, void 0, 72);
      }
      $iconsPurchased = $("#icons-purchased");
      if ($iconsPurchased.length > 0) {
        purchased_url = "//" + url_to_array[2] + "/" + username + "/purchases/json";
        list = new Backbone_Icon_List("#icons-purchased", purchased_url, 2);
      }
      $iconsFlagged = $("#flagged-uploads");
      if ($iconsFlagged.length > 0) {
        flagged_url = "//" + url_to_array[2] + "/" + username + "/uploads/flagged/json/";
        if ($("#handlebar-template-uploads").length > 0) {
          user_uploads_template = $("#handlebar-template-uploads");
        }
        list = new Backbone_Icon_List("#flagged-uploads", flagged_url, 2, user_uploads_template, 72);
      }
      $iconsPending = $("#pending-uploads");
      if ($iconsPending.length > 0) {
        if ($("#handlebar-template-uploads").length > 0) {
          user_uploads_template = $("#handlebar-template-uploads");
        }
        pending_url = "//" + url_to_array[2] + "/" + username + "/uploads/pending/json";
        list = new Backbone_Icon_List("#pending-uploads", pending_url, 2, user_uploads_template, 72);
      }
    }
    $("body").on("click", ".more-information", function (e) {
      var contextIcon = void 0;
      var contextUrl = void 0;
      e.preventDefault();
      contextIcon = $(this).data("icon-id");
      contextUrl = $(this).data("url");
      return $.ajax({
        url: contextUrl,
        method: "GET",
        success: function success(data, status, xhr) {

          $("body").append(data);
          return $("#information-modal").addClass("visible");
        },
        error: function error() {
          return console.log("Something went wrong");
        }
      });
    });
    $("body").on("click", ".close-information-modal", function (e) {
      e.preventDefault();
      return closeInformationModal();
    });
    closeInformationModal = function closeInformationModal() {
      $("#information-modal").removeClass("visible");
      return setTimeout(function () {
        return $("#information-modal").remove();
      }, 100);
    };
    $(".flip-card").on("click", function (e) {
      var parent = void 0;
      e.preventDefault();
      parent = $(this).parents("li.icon");
      return parent.addClass("flipped");
    });
    $(".nevermind").on("click", function (e) {
      var parent = void 0;
      e.preventDefault();
      parent = $(this).parents("li.icon");
      return parent.removeClass("flipped");
    });
    $(".delete-icon").on("click", function (e) {
      var contextIcon = void 0;
      var contextUrl = void 0;
      var parent = void 0;
      e.preventDefault();

      contextIcon = $(this).data("icon-id");
      contextUrl = $(this).data("url");
      parent = $(this).parents("li.icon");

      return $.ajax({
        url: contextUrl,
        method: "POST",
        data: {
          icon_id: contextIcon
        },
        success: function success(data, status, xhr) {
          parent.addClass("remove");
          parent.fadeOut(300);
          return setTimeout(function () {
            return parent.remove();
          }, 500);
        },
        error: function error() {
          return console.log("Something went wrong");
        }
      });
    });
    share_modal = {
      type: "share",
      style: "full-blur",
      authenticate: false
    };
    on_finish = function on_finish() {
      return $(".close-button").on("click", function (e) {
        e.preventDefault();
        return noun_modal.dismiss();
      });
    };
    return share = noun_modal.init(share_modal, $("body"), "click", on_load = on_finish, authentication = false, "button.share");
  });
};

exports.default = Accounts;